import { PRIVATE, PK12, INPROGRESS } from "../../constants";
export const dynoCreationData = (dyno, isPdf = false) => {
  return {
    dynoContent: "",
    dynoTitle: "Untitled EdDoc",
    dynoTitleNoCase: "untitled eddoc",
    dynoPublishingStatus: INPROGRESS,
    description: "",
    isFeatured: !!dyno.isFeatured,
    isPDFExport: !!dyno.isPDFExport,
    isDocExport: !!dyno.isDocExport,
    accessType: `${dyno.accessType}` || PRIVATE,
    allowCopy: !!dyno.allowCopy,
    viewCount: Number(`${dyno.viewCount}`) || 0,
    isTemplate: false,
    ...(isPdf
      ? {
          isDynamicFields: `${dyno.isDynamicFields}` || false,
        }
      : ""),
    ...(isPdf
      ? {
          isMultipleOptions: `${dyno.isMultipleOptions}` || false,
        }
      : ""),
    owner: { connect: { id: `${dyno.owner.id}` } },
    dynoType: {
      connect: {
        id: `${dyno.dynoType.id}`,
      },
    },
    status: {
      connect: {
        id: `${dyno.status.id}`,
      },
    },
    locale: {
      connect: {
        id: `${dyno.locale.id}`,
      },
    },
    localeDate: {
      connect: {
        id: `${dyno.localeDate.id}`,
      },
    },
    category: {
      connect: {
        id: `${dyno.category.id}`,
      },
    },
    tags: {
      connect: [...(!!dyno.tags ? dyno.tags.map((x) => `{id: ${x.id}}`) : "")],
    },
  };
};
export const getDynoType = (types, typeName) => {
  return types.find((x) => x.name === typeName.name);
};
export const getDynoStatus = (statuses, statusName) => {
  return statuses.find((x) => x.statusType === statusName);
};
export const getLocale = (locales, name) => {
  return locales.find((x) => x.name === name);
};
export const getLocaleDate = (localeDates, name) => {
  return localeDates.find((x) => x.name === name);
};
export const getCategory = (categories, name) => {
  return categories.find((x) => x.name === name);
};

export const newDyno = (props, type, exportFrom) => {
  return {
    dynoContent: "",
    dynoTitle: "New EdDoc",
    dynoTitleNoCase: "new eddoc",
    description: "",
    isFeatured: false,
    isPDFExport: exportFrom === "isPDFExport",
    isDocExport: exportFrom === "isDocExport",
    accessType: PRIVATE,
    allowCopy: true,
    viewCount: 0,
    owner: props.user,
    dynoType: type
      ? getDynoType(props.dynoTypes, type)
      : getDynoType(props.dynoTypes, "Reading"),
    status: getDynoStatus(props.dynoStatuses, "Draft"),
    locale: getLocale(props.locales, "en"),
    localeDate: getLocaleDate(props.localeDates, "en"),
    category: getCategory(props.dynoCategories, PK12),
  };
};
